import { AnalyticsPage } from './analytics';
import { Injectable } from '@angular/core';
import { UtilityService } from '@irb-common/services/utility.service';


@Injectable({
  providedIn: 'root'
})
export class AnalyticsService {
  private DEBUG: boolean;
  private isUiUnitTest: boolean = false;

  constructor(private util: UtilityService) {
    this.isUiUnitTest = (window as any).unittestrunningflag;
    this.DEBUG = this.util.getEnv() !== "PROD" && !this.isUiUnitTest;
  }

  private trackPageName(analyticsPage: AnalyticsPage) {
    if (window.tms && typeof window.tms.trackPage === 'function') {
        window.tms.trackPage(analyticsPage);
        if (!this.isUiUnitTest)
          this.DEBUG && console.log('[Analytics]', analyticsPage);
    } else {
        if (!this.isUiUnitTest)
          this.DEBUG && console.error('[Analytics]', 'NOT_READY', analyticsPage);
    }
  }
  
  trackClickEvent(linkName: string, fireOnce?: boolean) {
    if(typeof fireOnce == "undefined") {
      fireOnce = true;
    }

    let actualLinkName = "adobe-" + linkName + ((fireOnce) ? "|fireonce" : "");

    if(typeof window.GUTtrack === "function") {
        window.GUTtrack(actualLinkName);
      if (!this.isUiUnitTest)
        this.DEBUG && console.log('[Analytics]', actualLinkName);
    } else {
      if (!this.isUiUnitTest)
        this.DEBUG && console.error('[Analytics]', 'NOT_READY', actualLinkName);
    }
  }

  trackPassiveEvent(linkName: string) {
    let actualLinkName = "linkid-" + linkName;

    if(typeof window.GUTtrack === "function") {
        window.GUTtrack(actualLinkName);
      if (!this.isUiUnitTest)
        this.DEBUG && console.log('[Analytics]', actualLinkName);
    } else {
      if (!this.isUiUnitTest)
        this.DEBUG && console.error('[Analytics]', 'NOT_READY', actualLinkName);
    }
  }

  trackEditRebalance(schedule: string) {
    if (schedule && schedule === 'None') {
      this.trackPassiveEvent("lc_process");
    } else {
      this.trackPassiveEvent("lc_schedule");
    }
  }
  
  trackLoginEvent() {
    //this.trackPageName(AnalyticsPage.IREBAL_LOGIN);
  }
  trackHomeEvent() {
    this.trackPageName(AnalyticsPage.IREBAL_HOME);
  }
  trackCashReportEvent() {
    this.trackPageName(AnalyticsPage.IREBAL_CASH_REPORT);
  }
  trackAllocationReportEvent() {
    this.trackPageName(AnalyticsPage.IREBAL_ALLOCATION_REPORT);
  }
  trackPortfolioEvent() {
    this.trackPageName(AnalyticsPage.IREBAL_PORTFOLIO);
  }
  trackEditPortfolioEvent() {
    //this.trackPageName(AnalyticsPage.IREBAL_EDIT_PORTFOLIO);
  }
  trackEditMultiPlePortfoliosEvent() {
    //this.trackPageName(AnalyticsPage.IREBAL_EDIT_MULTIPLE_PORTFOLIOS);
  }
  trackAccountsEvent() {
    this.trackPageName(AnalyticsPage.IREBAL_ACCOUNTS);
  }
  trackEditAccountEvent() {
    //this.trackPageName(AnalyticsPage.IREBAL_EDIT_ACCOUNT);
  }
  trackEditMultipleAccountsEvent() {
    //this.trackPageName(AnalyticsPage.IREBAL_EDIT_MULTIPLE_ACCOUNTS);
  }
  trackUnassignedAccountsEvent() {
    this.trackPageName(AnalyticsPage.IREBAL_UNASSIGNED_ACCOUNTS);
  }
  trackModelsEvent() {
    this.trackPageName(AnalyticsPage.IREBAL_MODELS);
  }
  trackModelsEditSecurityModelEvent() {
    //this.trackPageName(AnalyticsPage.IREBAL_MODELS_EDIT_SECURITY_MODEL);
  }
  trackModelsEditBlendedModelEvent() {
    //this.trackPageName(AnalyticsPage.IREBAL_MODELS_EDIT_BLENDED_MODEL);
  }
  trackModelMarketCenterEvent() {
    this.trackPageName(AnalyticsPage.IREBAL_MODEL_MARKET_CENTER);
  }
  trackModelMarketCenterDetailEvent() {
    //this.trackPageName(AnalyticsPage.IREBAL_MODEL_MARKET_CENTER_DETAIL);
  }
  trackSecuritiesEvent() {
    //this.trackPageName(AnalyticsPage.IREBAL_SECURITIES);
  }
  trackSecuritiesEditEvent() {
    //this.trackPageName(AnalyticsPage.IREBAL_SECURITIES_EDIT);
  }
  trackCreateRebalanceEvent() {
    this.trackPageName(AnalyticsPage.IREBAL_CREATE_REBALANCE);
  }
  trackRebalanceResultsEvent() {
    //this.trackPageName(AnalyticsPage.IREBAL_REBALANCE_RESULTS);
  }
  trackRebalanceResultSummaryEvent() {
    this.trackPageName(AnalyticsPage.IREBAL_REBALANCE_RESULT_SUMMARY);
  }
  trackRebalanceResultDetailEvent() {
    this.trackPageName(AnalyticsPage.IREBAL_PORTFOLIO_RESULT_DETAIL);
  }
  trackScheduledRebalancesEvent() {
    //this.trackPageName(AnalyticsPage.IREBAL_SCHEDULED_REBALANCES);
  }
  trackScheduledRebalancesEditEvent() {
    //this.trackPageName(AnalyticsPage.IREBAL_SCHEDULED_REBALANCES_EDIT);
  }
  trackOrderBlotterActiveEvent() {
    //this.trackPageName(AnalyticsPage.IREBAL_ORDER_BLOTTER_ACTIVE);
  }
  trackOrderBlotterActiveTradeDetailsEvent() {
    //this.trackPageName(AnalyticsPage.IREBAL_ORDER_BLOTTER_ACTIVE_TRADE_DETAILS);
  }
  trackOrderBlotterClosedEvent() {
    //this.trackPageName(AnalyticsPage.IREBAL_ORDER_BLOTTER_CLOSED);
  }
  trackOrderBlotterClosedTradeDetailsEvent() {
    //this.trackPageName(AnalyticsPage.IREBAL_ORDER_BLOTTER_CLOSED_TRADE_DETAILS);
  }
  trackGlobalSettingsSecuritiesEvent() {
    //this.trackPageName(AnalyticsPage.IREBAL_GLOBAL_SETTINGS_SECURITIES);
  }
  trackGlobalSettingsAccountsEvent() {
    //this.trackPageName(AnalyticsPage.IREBAL_GLOBAL_SETTINGS_ACCOUNTS);
  }
  trackGlobalSettingsPortfoliosEvent() {
    //this.trackPageName(AnalyticsPage.IREBAL_GLOBAL_SETTINGS_PORTFOLIOS);
  }
  trackGlobalSettingsModelsEvent() {
    //this.trackPageName(AnalyticsPage.IREBAL_GLOBAL_SETTINGS_MODELS);
  }
  trackGlobalSettingsRebalancingEvent() {
    //this.trackPageName(AnalyticsPage.IREBAL_GLOBAL_SETTINGS_REBALANCING);
  }
  trackGlobalSettingsTradingEvent() {
    //this.trackPageName(AnalyticsPage.IREBAL_GLOBAL_SETTINGS_TRADING);
  }

  trackAutoRebalanceReport() {
    this.trackPageName(AnalyticsPage.IREBAL_AUTO_REBALANCE_REPORT);
  }

  trackErrors(errorSummary: any) {
    return errorSummary;
    /*const o: any = {
      actionName: AnalyticsAction.ERROR,
      context: '',
      details: errorSummary
    };
    analytics.track(o);*/
  }

}
